export const PaginateParamMap = {
	INDEX: 'index',
	LIMIT: 'limit',
	SORT: 'sort',
	SORT_BY: 'sort-by',
}
